module.exports = __webpack_public_path__ + "static/media/popup-arrow.7db5ed52.svg";